<template>
  <div class="salaries-list">
    <b-table
      primary-key="off_cycle_payment_id"
      :items="props.offCyclePayments"
      :fields="FIELDS"
      class="mb-3"
      table-class="table-minimal"
      show-empty
    >
      <template v-slot:cell(goTo)="data">
        <div class="go-to" @click="viewBatch(data?.item)" :id="`see-more-${data?.item?.batch}`">
          <CaretRight />
        </div>
      </template>
    </b-table>
  </div>
</template>

<script setup>
import { toCurrency } from '@/utils';
import CaretRight from '@/assets/icons/CaretRight.vue';
import { useMutation } from '@tanstack/vue-query';
import { downloadOffCycleInvoice } from '@/queries/one-time-payments';
import { ref, watch } from 'vue';
import { useRouter } from 'vue-router/composables';

const props = defineProps({
  employeeId: {
    type: String,
    required: true,
  },
  offCyclePayments: {
    type: Array,
    required: true,
  },
});

const isDownloading = ref('');
const downloadInvoiceMutation = useMutation(downloadOffCycleInvoice());
const router = useRouter();

watch(downloadInvoiceMutation.isPending, isPending => {
  if (isPending) {
    isDownloading.value = downloadInvoiceMutation?.variables?.value;
  } else {
    isDownloading.value = '';
  }
});

const FIELDS = [
  { key: 'employee_code', label: 'Employee Code' },
  { key: 'payment_type', label: 'Reason', formatter: value => value.split('_').join(' ') },
  { key: 'amount', label: 'Amount', formatter: value => toCurrency(value, 'USD') },
  { key: 'goTo', label: '', thStyle: { width: '20px' }, tdStyle: { width: '20px' } },
];

const viewBatch = batch => {
  router.push({ name: 'one-time-payment', params: { batchId: batch.off_cycle_payment_group_id } });
};
</script>

<style>
.off-cycle-payment__icon {
  color: var(--palette-color-brand-primary);
}

.overdue {
  color: var(--palette-color-danger);
  background-color: var(--palette-color-danger-lighten-90);
  padding: 0.5rem;
  border-radius: 0.5rem;
  text-align: center;
  font-weight: bold;
}

.open {
  color: var(--palette-color-warning);
  background-color: var(--palette-color-warning-lighten-90);
  padding: 0.5rem;
  border-radius: 0.5rem;
  text-align: center;
  font-weight: bold;
}

.paid {
  color: var(--palette-color-success);
  background-color: var(--palette-color-success-lighten-90);
  padding: 0.5rem;
  border-radius: 0.5rem;
  text-align: center;
  font-weight: bold;
}

.download-spinner {
  width: 1.5rem;
  height: 1.5rem;
}

.go-to {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    cursor: pointer;

    svg {
      fill: var(--palette-color-brand-primary);
    }
  }
}
</style>
